import React from "react";
import { map } from "lodash";
import { Locale } from "@linkfluence/models/locale";
import Sidebar from "@radarly/components/panels/card-library/sidebar";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { CardViz, Section, Sections } from "./";

const formatMenuSection = (
  id: string,
  section: Section | CardViz,
  locale: Locale,
  subsection: boolean = true
) => ({
  id,
  title: section.title ? section.title : getTranslation(locale, id),
  subsection,
});

const getTranslation = (locale: Locale, id: string) => {
  return tr(locale, "CUSTOM_PAGES::EDITOR::CARD_LIBRARY::" + id);
};

interface SharedPanelsCardEditionCardLibrarySidebarProps {
  sections: Sections;
  setCurrentSection: (id: string) => void;
}

export default function SharedPanelsCardEditionCardLibrarySidebar({
  sections,
  setCurrentSection,
}: SharedPanelsCardEditionCardLibrarySidebarProps) {
  const locale = useCurrentUserLocale();

  return (
    <Sidebar
      sections={map(sections, (mainSection, id) => ({
        ...formatMenuSection(id, mainSection, locale),
        sections: mainSection.sections
          ? map(mainSection.sections, (subsection, id) => ({
              ...formatMenuSection(id, subsection, locale),
            }))
          : map(mainSection.cards, (card, cardId) => ({
              ...formatMenuSection(cardId, card, locale, false),
            })),
      }))}
      onClickSection={(id) => setCurrentSection(id)}
    />
  );
}
